/* eslint-disable */
import { observable, action } from 'mobx'
import axios from 'axios'

import Auth from './Auth'
import Community from './Community'

import config from '../config'

class Application {
  @observable all = []
  @observable my = []

  @observable
  response = {
    decision: null
  }

  @action
  getAllApplications = () => {
    return axios({
      method: 'get',
      url: `${
        config.api_uri
      }/search/?type=application&q=pending:true&sortKey=createdAt&sortType=desc`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.all.replace([
          ...res.data.hits.hits.reduce(
            (arr, u) => [...arr, ...(u._source ? [u._source] : [])],
            []
          )
        ])

        return this.all.slice()
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getApplication = comId => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/community/${comId}/application`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        const { community, ...application } = res.data.data

        if (!application) {
          return Promise.reject()
        }

        {
          const index = this.all.slice().findIndex(a => a.comId === comId)
          this.all.replace([
            ...(index > -1
              ? [
                  ...this.all.slice(0, index),
                  application,
                  ...this.all.slice(index + 1)
                ]
              : [...this.all.slice(), application])
          ])
        }

        if (Community.my.slice().find(c => c.id === comId)) {
          const index = this.my.slice().findIndex(a => a.comId === comId)
          this.my.replace([
            ...(index > -1
              ? [
                  ...this.my.slice(0, index),
                  application,
                  ...this.my.slice(index + 1)
                ]
              : [...this.my.slice(), application])
          ])
        }

        return application
      })
      .catch(e => {
        console.warn(e)
        return Promise.reject(e)
      })
  }

  @action
  postApplicationDecision = data => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/community/${data.comId}/application`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        approved: !!data.approved,
        comment: data.comment
      }
    })
      .then(res => {
        {
          const index = this.all.slice().findIndex(a => a.comId === data.comId)
          this.all.replace([
            ...(index > -1
              ? [
                  ...this.all.slice(0, index),
                  {
                    ...this.all.slice()[index],
                    approved: !!data.approved,
                    pending: false,
                    comment: data.comment
                  },
                  ...this.all.slice(index + 1)
                ]
              : [
                  ...this.all.slice(),
                  {
                    ...this.all.slice()[index],
                    approved: !!data.approved,
                    comment: data.comment
                  }
                ])
          ])
        }

        if (Community.my.slice().find(c => c.id === data.comId)) {
          const index = this.my.slice().findIndex(a => a.comId === data.comId)
          this.my.replace([
            ...(index > -1
              ? [
                  ...this.my.slice(0, index),
                  {
                    ...this.my.slice()[index],
                    approved: !!data.approved,
                    comment: data.comment
                  },
                  ...this.my.slice(index + 1)
                ]
              : [
                  ...this.my.slice(),
                  {
                    ...this.my.slice()[index],
                    approved: !!data.approved,
                    comment: data.comment
                  }
                ])
          ])
        }
      })
      .catch(e => {
        console.warn(e)
        return Promise.reject(e)
      })
  }
}

export default new Application()



// WEBPACK FOOTER //
// ./src/stores/Application.js